<template lang="pug">
  #container
    p {{placeholder}}
    el-date-picker.width(
      v-model="value"
      type="daterange"
      start-placeholder="Data Inicial"
      end-placeholder="Data Final"
      unlink-panels
      format="dd/MM/yyyy",
      :picker-options="pickerOptions"
    )
      span(slot="range-separator") até
</template>

<script>
export default {
  name: 'InputEntreDatas',
  props: {
    placeholder: {
      type: String,
      required: true
    },
    calendario: {
      type: Array
    }
  },
  data () {
    return {
      value: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: 'Últimos 7 dias',
          onClick (picker) {
            this.value = []
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Últimos 30 dias',
          onClick (picker) {
            this.value = []
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Últimos 90 dias',
          onClick (picker) {
            this.value = []
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
    value () {
      this.$emit('input', this.value || null)
    },
    calendario: {
      immediate: true,
      handler () {
        if (this.value !== this.calendario) {
          this.value = this.calendario
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .width {
    width: 18.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/InputEntreDatas.vue